import React, { useState ,useEffect} from 'react';
import axios from 'axios';
import { MdCloudUpload, MdDelete } from 'react-icons/md';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AiFillFileExcel } from 'react-icons/ai';
import Modal from 'react-modal'; 
import '../../StylesCSS/uploader.css'; 
import { useUser } from '../../context/UserContext';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { API_BASE_URL } from '../dashboardContent/config'; 
import { useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';



// Style personnalisé pour la modal
const customModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#f9f9f9',
        padding: '20px',
        borderRadius: '10px',
        width: '400px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
};

const ImportFileExcel = ({ setActiveSection }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const routeContext = location.state || {};
    const {
        branch,
        branchLabel,
        action,
    } = routeContext;

    /* Start MSL30082026 */
    const [files, setFiles] = useState([]);
    const [fileNames, setFileNames] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false); // Gérer l'état de la modal
    const [fileExistsModalIsOpen, setFileExistsModalIsOpen] = useState(false); // Gérer l'état de la modal d'existence de fichier
    const [branchMismatchModalIsOpen, setBranchMismatchModalIsOpen] = useState(false);
    const [branchMismatchDetails, setBranchMismatchDetails] = useState(null);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [excelFiles, setExcelFiles] = useState([]);

    const { userId } = useUser();

    /* Start MSL30082026 */
    useEffect(() => {
      if (!userId) return;

      const fetchExcelFiles = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/version2/api/excel`, {
            params: {
              userId,
              branchLabel: branchLabel || '',
            },
          });
          console.log('=== ImportFileExcel: fichiers Excel chargés ===');
          console.log('userId:', userId);
          console.log('branch:', branch);
          console.log('branchLabel:', branchLabel);
          console.log('response.data:', response.data);
          setExcelFiles(response.data);
        } catch (error) {
          console.error('Erreur lors de la récupération des fichiers Excel', error);
        }
      };

      fetchExcelFiles();
    }, [userId, branch, branchLabel]);
    /* End MSL30082026 */
  
    /* Start MSL30082026 */
    const confirmDeleteExcelFile = async () => {
      if (!fileToDelete) {
        return;
      }

      try {
        await axios.delete(`${API_BASE_URL}/version2/api/excel/${fileToDelete.id}`);
        setExcelFiles(prev => prev.filter(file => file.id !== fileToDelete.id));
      } catch (error) {
        console.error('Erreur lors de la suppression du fichier Excel', error);
      } finally {
        setFileToDelete(null);
      }
    };
    const handleFileUpload = (event) => {
        const uploadedFiles = Array.from(event.target.files);
        setFileNames(uploadedFiles.map(file => file.name));
        setFiles(uploadedFiles);
    };

    const normalizeBranchLabel = (value) => String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/الجذع\s+المشترك/g, 'جذع مشترك')
      .replace(/جذع\s+المشترك/g, 'جذع مشترك')
      .replace(/الآداب\s+و\s+العلوم/g, 'الآداب والعلوم');

    const normalizeExcelValue = (value) => normalizeBranchLabel(value).toLocaleLowerCase();

    const getAdjacentCellValue = (sheet, row, column) => {
      const candidates = [
        sheet[XLSX.utils.encode_cell({ r: row, c: column + 1 })],
        sheet[XLSX.utils.encode_cell({ r: row, c: column - 1 })],
        sheet[XLSX.utils.encode_cell({ r: row + 1, c: column })],
        sheet[XLSX.utils.encode_cell({ r: row - 1, c: column })],
      ];

      return candidates.find((cell) => cell?.w ?? cell?.v)?.w ?? candidates.find((cell) => cell?.w ?? cell?.v)?.v ?? '';
    };

    const findLabeledValue = (sheet, labels) => {
      const normalizedLabels = labels.map(normalizeExcelValue);
      const range = XLSX.utils.decode_range(sheet['!ref'] || 'A1:A1');

      for (let row = range.s.r; row <= range.e.r; row += 1) {
        for (let column = range.s.c; column <= range.e.c; column += 1) {
          const cell = sheet[XLSX.utils.encode_cell({ r: row, c: column })];
          const cellValue = normalizeExcelValue(cell?.w ?? cell?.v);
          if (normalizedLabels.some((label) => cellValue.includes(label))) {
            const adjacentValue = getAdjacentCellValue(sheet, row, column);
            if (adjacentValue) return adjacentValue;
          }
        }
      }

      return '';
    };

    const getFileMetadata = async (file) => {
      const workbook = XLSX.read(await file.arrayBuffer(), { type: 'array' });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1, defval: '' });
      const niveauCell = firstSheet?.F7;
      const niveau = niveauCell?.w ?? niveauCell?.v;

      const getValueFromRows = (labels) => {
        const normalizedLabels = labels.map(normalizeExcelValue);
        for (let rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
          const row = rows[rowIndex].map(normalizeExcelValue);
          const labelIndex = row.findIndex((cell) => normalizedLabels.some((label) => cell.includes(label)));
          if (labelIndex === -1) continue;

          const values = [
            rows[rowIndex][labelIndex + 1],
            rows[rowIndex + 1]?.[labelIndex],
            rows[rowIndex][labelIndex - 1],
          ];
          const value = values.find((item) => normalizeExcelValue(item));
          if (value) return value;
        }
        return '';
      };

      return {
        institution: getValueFromRows(['المؤسسة الأصلية', 'المؤسسة', 'institution'])
          || findLabeledValue(firstSheet, ['المؤسسة الأصلية', 'المؤسسة', 'institution']),
        niveau: niveau || getValueFromRows(['المستوى', 'الجذع المشترك', 'niveau']),
        classe: getValueFromRows(['القسم', 'classe', 'class'])
          || findLabeledValue(firstSheet, ['القسم', 'classe', 'class']),
      };
    };

    /* Start MSL30082026 */
    const handleSubmit = async () => {
        if (files.length === 0) {
            alert('Please upload at least one file.');
            return;
        }

        const selectedLabel = normalizeBranchLabel(branchLabel);
        for (const file of files) {
          try {
            const metadata = await getFileMetadata(file);
            const fileLabel = normalizeBranchLabel(metadata.niveau);
            if (!fileLabel || fileLabel !== selectedLabel) {
              setBranchMismatchDetails({
                fileName: file.name,
                fileLabel: fileLabel || '(niveau introuvable)',
                selectedLabel,
              });
              setBranchMismatchModalIsOpen(true);
              return;
            }

            const duplicateFile = excelFiles.find((existingFile) => (
              normalizeExcelValue(existingFile.institution) === normalizeExcelValue(metadata.institution)
              && normalizeExcelValue(existingFile.niveau) === normalizeExcelValue(metadata.niveau)
              && normalizeExcelValue(existingFile.classe) === normalizeExcelValue(metadata.classe)
              && normalizeExcelValue(metadata.institution) !== ''
              && normalizeExcelValue(metadata.classe) !== ''
            ));

            if (duplicateFile) {
              setFileExistsModalIsOpen(true);
              return;
            }
          } catch (error) {
            console.error(`Erreur lors de la lecture du niveau dans ${file.name}:`, error);
            setBranchMismatchDetails({
              fileName: file.name,
              fileLabel: '(niveau introuvable)',
              selectedLabel,
            });
            setBranchMismatchModalIsOpen(true);
            return;
          }
        }

        console.log('=== ImportFileExcel: soumission de fichiers ===');
        console.log('branch:', branch);
        console.log('branchLabel:', branchLabel);
        console.log('userId:', userId);
        console.log('files:', files.map(file => file.name));
    
        let success = true; // Variable pour vérifier si toutes les requêtes réussissent
    
        for (let i = 0; i < files.length; i++) {
            const formData = new FormData();
            formData.append('file', files[i]);
            formData.append('userId', userId);  // Ajoute l'ID de l'utilisateur ici
            formData.append('branch', branch || '');
            formData.append('branchLabel', branchLabel || '');
    
            try {
                console.log('=== ImportFileExcel: envoi API file ===');
                console.log('index:', i + 1);
                console.log('filename:', files[i].name);
                console.log('userId:', userId);
                console.log('branch:', branch);

                const response = await axios.post(`${API_BASE_URL}/version2/api/excel/save/${i+1}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                console.log(`File ${i+1} saved successfully:`, response.data);
            } catch (error) {
                if (error.response && error.response.status === 409) {  // Si le fichier existe déjà
                    console.error(`File ${i+1} already exists:`, error.response.data);
                    setFileExistsModalIsOpen(true); // Ouvrir la modal d'existence de fichier
                } else {
                    console.error(`Error saving file ${i+1}:`, error);
                }
                success = false; // Marquer l'échec
            }
        }
    
        if (success) {
            setModalIsOpen(true); // Ouvre la modal si tout est OK
        }
    };
    /* End MSL30082026 */

    /* Start MSL30082026 */
    const handleGoBack = (section) => {
        navigate(`/${section}`, {
            state: {
                branch,
                branchLabel,
                action,
            },
        });
    };
    /* End MSL30082026 */


    return (
        <div className="excel-import-page" dir="rtl">
        <div className="excel-import-content" style={{ maxWidth: '600px', margin: 'auto' }}>
            <bR></bR>
            <div
          style={{
            display: "flex",
            justifyContent: "center", // Centrage horizontal
            alignItems: "center",

            backgroundColor: "#00B9B9",
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            direction: "rtl",
            fontFamily: "Arial, sans-serif",
            fontSize: "22px",
            fontWeight: "bold",
            height: "80px",
            gap: "20px",
          }}
        >
          {/* Carré à droite (début de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>

          {/* Texte arabe centré */}
          <span>تدبير مجالس الأقســــام للجدع المشترك</span>

          {/* Carré à gauche (fin de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>
        </div>
        <br></br>
            <div
              style={{
                margin: '0 auto 20px',
                padding: '14px 20px',
                backgroundColor: '#e8fafa',
                border: '2px solid #00b9b9',
                borderRadius: '8px',
                color: '#006b6b',
                textAlign: 'center',
                fontSize: '24px',
                fontWeight: 'bold',
              }}
            >
              نوع الجذع المختار: {branchLabel || 'غير محدد'}
            </div>
            <div className="excel-import-heading">
              <span>استيراد المعطيات</span>
              <h2>تحميل الملفات</h2>
              <p>أضف ملفات Excel الخاصة بالنتائج لإدماجها في النظام.</p>
            </div>
            <main>
                <form
                    onClick={() => document.querySelector(".input-field").click()}
                    className="uploader-form"
                >
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        className="input-field"
                        hidden
                        multiple
                        onChange={handleFileUpload}
                    />
                    {fileNames.length > 0 ? (
                        fileNames.map((fileName, index) => (
                            <div key={index} className="uploaded-row">
                                <AiFillFileExcel color='#1475cf' />
                                <span className='upload-content'>
                                    {fileName}
                                    <MdDelete
                                        onClick={() => {
                                            setFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
                                            setFileNames(prevFileNames => prevFileNames.filter((_, i) => i !== index));
                                        }}
                                    />
                                </span>
                            </div>
                        ))
                    ) : (
                        <>
                            <MdCloudUpload color='#1475cf' size={60} />
                            <p>Browse Files to upload</p>
                        </>
                    )}
                </form>

                <div className="excel-import-actions" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
  <button
    onClick={handleSubmit}
    className='submit-button'
    style={{ marginBottom: '10px' }} // Ajouter un espacement entre les boutons
  >
    تاكيد
  </button>
  <button 
    onClick={() => handleGoBack('PageLayoutActionsV2')}
    className="backbtn"
  >
    <FontAwesomeIcon icon={faArrowLeft} /> رجوع
  </button>
</div>



                <Modal
                  isOpen={!!fileToDelete}
                  onRequestClose={() => setFileToDelete(null)}
                  style={customModalStyles}
                  contentLabel="تأكيد حذف الملف"
                  ariaHideApp={false}
                >
                  <div dir="rtl" style={{ textAlign: 'center' }}>
                    <h2 style={{ color: '#b42318', marginBottom: '12px' }}>تأكيد حذف الملف</h2>
                    <p style={{ fontSize: '16px', lineHeight: 1.8, marginBottom: '22px' }}>
                      هل أنت متأكد من رغبتك في حذف هذا الملف؟ لا يمكن التراجع عن هذا الإجراء.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                      <button
                        onClick={confirmDeleteExcelFile}
                        style={{
                          backgroundColor: '#dc3545',
                          color: 'white',
                          minWidth: '100px',
                          padding: '10px 20px',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '16px',
                          fontWeight: 700,
                        }}
                      >
                        نعم
                      </button>
                      <button
                        onClick={() => setFileToDelete(null)}
                        style={{
                          backgroundColor: '#6c757d',
                          color: 'white',
                          minWidth: '100px',
                          padding: '10px 20px',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '16px',
                          fontWeight: 700,
                        }}
                      >
                        لا
                      </button>
                    </div>
                  </div>
                </Modal>

                {/* Modal de confirmation */}
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={() => setModalIsOpen(false)}
                    style={customModalStyles}
                    contentLabel="Confirmation"
                    ariaHideApp={false} // Désactive l'avertissement pour tester (optionnel)
                >
                    <div style={{ textAlign: 'center' }}>
                        <h2 style={{ color: '#1475cf' }}>Succès</h2>
                        <p style={{ fontSize: '16px', marginBottom: '20px' }}>
                            Les données ont été enregistrées avec succès !
                        </p>
                        <button
                            onClick={() => setModalIsOpen(false)}
                            style={{
                                backgroundColor: '#1475cf',
                                color: 'white',
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px',
                            }}
                        >
                            Fermer
                        </button>
                    </div>
                </Modal>
                <Modal
    isOpen={fileExistsModalIsOpen}
    onRequestClose={() => setFileExistsModalIsOpen(false)}
    style={customModalStyles}
    contentLabel="Erreur"
    ariaHideApp={false}
>
    <div style={{ textAlign: 'center' }}>
        <h2 style={{ color: '#e74c3c' }}>Erreur</h2>
        <p style={{ fontSize: '16px', marginBottom: '20px' }}>
            Le fichier que vous avez importé existe déjà dans la base de données.
        </p>
        <button
            onClick={() => setFileExistsModalIsOpen(false)}
            style={{
                backgroundColor: '#e74c3c',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
            }}
        >
            Fermer
        </button>
    </div>
</Modal>

<Modal
  isOpen={branchMismatchModalIsOpen}
  onRequestClose={() => setBranchMismatchModalIsOpen(false)}
  style={customModalStyles}
  contentLabel="Branche incompatible"
  ariaHideApp={false}
>
  <div style={{ textAlign: 'center', direction: 'rtl' }}>
    <h2 style={{ color: '#e74c3c' }}>Erreur</h2>
    <p style={{ fontSize: '17px', marginBottom: '12px', direction: 'rtl', textAlign: 'right' }}>
      ملف Excel الذي تريد إضافته لا يناسب الجذع المشترك الذي اخترته.
      <br />
      المرجو اختيار ملف Excel الخاص بالجذع المشترك المحدد ثم إعادة المحاولة.
    </p>
    {branchMismatchDetails && (
      <div style={{ fontSize: '14px', marginBottom: '20px', direction: 'rtl', textAlign: 'right', lineHeight: '1.8' }}>
        <div>اسم الملف : <strong dir="ltr">{branchMismatchDetails.fileName}</strong></div>
        <div>الجذع الموجود في ملف Excel : <strong>{branchMismatchDetails.fileLabel}</strong></div>
        <div>الجذع الذي اخترته : <strong>{branchMismatchDetails.selectedLabel}</strong></div>
      </div>
    )}
    <button
      onClick={() => setBranchMismatchModalIsOpen(false)}
      style={{
        backgroundColor: '#e74c3c',
        color: 'white',
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px',
      }}
    >
      Fermer
    </button>
  </div>
</Modal>

            </main>
        </div>
        <br></br>
            <div className="excel-files-section" style={{ maxWidth: '900px', margin: 'auto' }}>
        <div className="excel-files-heading">
          <span>الأرشيف</span>
          <h2>قائمة ملفات إكسل</h2>
        </div>
      <div className="excel-files-table-wrap">
      <table className="excel-files-table" border="1" cellPadding="10">
        <thead>
          <tr>
    <th>إجراء</th>
    <th>المستوى</th>
    <th>نيابة</th>
    <th>المؤسسة</th>
    <th>القسم</th>
    <th>السنة الدراسية</th>
    <th>الأكاديمية</th>

           
          </tr>
        </thead>
        <tbody>
          {excelFiles.map((file) => (
            <tr key={file.id}>
                 <td>
                <button onClick={() => setFileToDelete(file)}>Supprimer</button>
              </td>
               <td>{file.niveau}</td>
      <td>{file.nieba}</td>
      <td>{file.institution}</td>
      <td>{file.classe}</td>
      <td>{file.anneeScolaire}</td>
      <td>{file.academie}</td>
             
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
    </div>
    );
};

export default ImportFileExcel;
